import { render, staticRenderFns } from "./InstagramIntegration.vue?vue&type=template&id=3a8b5de0&scoped=true&"
import script from "./InstagramIntegration.vue?vue&type=script&lang=ts&"
export * from "./InstagramIntegration.vue?vue&type=script&lang=ts&"
import style0 from "./InstagramIntegration.vue?vue&type=style&index=0&id=3a8b5de0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a8b5de0",
  null
  
)

export default component.exports